import React from 'react';
import styles from './LifeStyle.module.css';

const Lifestyle = ({ lang }) => {
  const data = {
    EN: {
      title: "Latest Lifestyle Trends",
      btn: "Load More",
      posts: [
        "Summer travel hacks for 2026", "Minimalist home office setups", 
        "Healthy diet plans for busy professionals", "Top 10 fashion picks",
        "Mental wellness in the digital age", "Sustainable living tips",
        "Weekend getaway ideas", "New culinary experiences"
      ]
    },
    UR: {                               
      title: "لیٹسٹ لائف اسٹائل ٹرینڈز",
      btn: "مزید لوڈ کریں",
      posts: [
        "2026 کے لیے موسم گرما کی سفری ٹپس", "گھر میں بہترین ہوم آفس کیسے بنائیں",
        "مصروف لوگوں کے لیے صحت بخش ڈائٹ پلان", "ٹاپ 10 فیشن پکس",
        "ڈیجیٹل دور میں ذہنی سکون", "پائیدار زندگی گزارنے کے طریقے",
        "ویک اینڈ گزارنے کے آئیڈیاز", "نئے کھانے کے تجربات"
      ]
    }
  }[lang];

  return (
    <section className={styles.lifestyleSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.lifestyleGrid}>
        {data.posts.map((post, i) => (
          <div key={i} className={styles.card}>
            <img src={`https://picsum.photos/300/200?random=${i + 3000}`} alt="lifestyle" />
            <div className={styles.cardInfo}>
              <h4>{post}</h4>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Lifestyle;